import { currentEnv } from './instance'

const clearLoginInfo = () => {
  app.$store.dispatch('fullToken', null)
  app.$store.dispatch('loginTips', true)
  app.$store.dispatch('hasLogin', false)
  localforage.clear()
  localStorage.clear()
  document.location.href = '/#/login'
}
const errorHandle = async (err, status, data) => {
  const errInfo = err.response
  if (_.includes([401, 403], status)) {
    const refreshToken = await localforage.getItem('accessToken')
    if (!refreshToken) {
      app.$message.warning('请先登录。')
      return clearLoginInfo()
    }
    const res = await axios.post(
      `${currentEnv.VUE_APP_DIY_SERVER}/api/SysUser/GetCurrentUser`,
      {},
      {
        headers: { Authorization: refreshToken },
      }
    )
    if (res.data && res.data.Code === 1) {
      localStorage.setItem('CurrentUser', JSON.stringify(res.data.Data))
      const fullToken = `Bearer ${res.headers.authorization}`
      localforage.setItem('fullToken', fullToken)
      localforage.setItem('accessToken', res.headers.authorization)
      axios.defaults.headers.common.Authorization = fullToken
      app.$store.dispatch('fullToken', fullToken)
      app.$store.dispatch('hasLogin', true)
      const instance = axios.create({
        headers: {
          'Content-Type': errInfo.config.headers['Content-Type'],
        },
      })
      let againRes = null
      if (errInfo.config && errInfo.config.method === 'get') {
        const newRes = await axios.get(errInfo.config.url)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      } else if (errInfo.config && errInfo.config.method === 'post') {
        const newRes = await instance.post(errInfo.config.url, errInfo.config.data)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      } else if (errInfo.config && errInfo.config.method === 'patch') {
        const newRes = await instance.patch(errInfo.config.url, errInfo.config.data)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      }
      return againRes
    }
    return clearLoginInfo()
  }
  if (status === 404) {
    return app.$message.error('请求的资源不存在')
  }
  if (status === 400) {
    return app.$message.error(data.msg)
  }
  if (data.code === 1) {
    return app.$message.error(data.msg)
  }
  return app.$message.error(err.message || err.msg || data.msg)
}

export default (err, res) => {
  if (err) {
    const info = JSON.parse(JSON.stringify(err))
    if (info && info.response) {
      return errorHandle(err, info.response.status, info.response.data)
    }
  }
  if (res && res.data.code) {
    app.$message.error(res.data.msg || res.data.message)
    return {
      code: res.data.code,
      data: res.data.data,
      message: res.data.msg,
      url: res.data.url,
    }
  }
  return res ? res.data : null
}
